'use strict';

angular.module('mobile-apps').factory('MobileAppLanguagesStatistics', [
    '$resource',
    function ($resource) {
        return $resource(
            'v1/projects/:mobileAppId/languages/statistics',
            {
                mobileAppId: '@mobileAppId'
            },
            {
                get:
                {
                    method:'GET',
                    cache: false,
                    isArray: true
                }
            }
        );
    }
]);
